export * from './NameSetting';
export { NameSetting as default } from './NameSetting';
